import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import LineFriendRepository from '@/repositories/lineFriendRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useLineFriendStore = defineStore({
    id: 'lineFriend',
    state: () => ({
        lineTag: '',
    }),
    getters: {},
    actions: {
        reset() {
            this.lineTag = '';
        },
        /**
         * LINEフレンド追加情報取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getLineFriendAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const lineFriendRepository = new LineFriendRepository();
            try {
                const response = await lineFriendRepository.getLineFriendApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.lineTag = response.data.LineTag;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
